import { type LocationHistory, useGetShiftLocationHistoryQuery } from "@ots-frontend/ots-data";
import { useEffect, useState } from "react";
import type { OtsMapPosition } from "../../components/OtsGoogleMap";
import { ActivityDayMap, type ActivityDayMapProps } from "../ActivityDayMap";
import { shiftBreadcrumbs } from "../model/activity-day-map";

/** Loads one shift's recorded road and hands it up; one per shift, as the endpoint is per shift. */
const ShiftRoad = ({ shiftId, database, onLoad }: { shiftId: string; database?: string; onLoad: (shiftId: string, history?: LocationHistory) => void }) => {
  const { data } = useGetShiftLocationHistoryQuery({ id: shiftId, database });
  useEffect(() => onLoad(shiftId, data), [shiftId, data, onLoad]);
  return null;
};

/** A driver's day on the map with each shift's recorded road. */
export const ConnectedActivityDayMap = (props: Omit<ActivityDayMapProps, "paths">) => {
  const shifts = props.driver.shifts.flatMap((group) => group.shift ? [group.shift] : []);
  const [roads, setRoads] = useState<Record<string, OtsMapPosition[]>>({});
  const [onLoad] = useState(() => (shiftId: string, history?: LocationHistory) =>
    setRoads((current) => ({ ...current, [shiftId]: shiftBreadcrumbs(history) })));
  return <>
    {shifts.map((shift) => <ShiftRoad key={shift.id} shiftId={shift.id} database={shift.database} onLoad={onLoad}/>)}
    <ActivityDayMap {...props} paths={shifts.map((shift) => roads[shift.id] ?? [])}/>
  </>;
};
